
import React from 'react';
import { useSelector } from 'react-redux';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { getMapLayers } from '../../../project';
import LayerSwitcherLegacyPanel from './LayerSwitcherLegacyPanel';
import LegendPanel from './LegendPanel';

import { Log } from '../../../core';
const log = Log.getLogger('MultiSceneForApp.layer.LayerSwitcherWithLegendPanel');

const LayerSwitcherWithLegendPanel = (props) => {

    const classNames = mergeStyleSets({
        LayerSwitcherWithLegendPanel: {
        },
        content: {
            overflowY: 'auto',
            height: 0
        },
        tabContent: {
        }
    });

    const project = useSelector(state => {
        return state.project;
    });

    let mapLayersDefs = getMapLayers(project);
    let existsLegend = mapLayersDefs.reduce((previous, actual) => {
        return (!!actual.legend || previous);
    }, false);

    let layerSwitcher = (
        <LayerSwitcherLegacyPanel
            layers={props.layers}
            groups={props.groups}
            map={props.map}
            onlyOverLayers={props.onlyOverLayers}
            moduleActions={props.moduleActions}
        />
    );

    let content = (existsLegend)
        ? <Pivot>
            <PivotItem headerText="Vrstvy" itemKey="layers">
                <div className={classNames.tabContent}>
                    {layerSwitcher}
                </div>
            </PivotItem>
            <PivotItem headerText="Legenda" itemKey="legend">
                <div className={classNames.tabContent}>
                    <LegendPanel
                        layers={props.layers}
                        mapLayersDefs={mapLayersDefs}
                    />
                </div>
            </PivotItem>
        </Pivot>
        : layerSwitcher;

    return (
        <Stack verticalFill className={classNames.LayerSwitcherWithLegendPanel}>
            <Stack.Item grow className={classNames.content}>
                {content}
            </Stack.Item>
        </Stack>
    );
};

export default LayerSwitcherWithLegendPanel;
